import { createContextHook } from '@/utils';
import { EntriesContext } from '../EntriesContext';

export const useEntriesContext = createContextHook(EntriesContext);
